export default {
    // 获取mq级联信息
    getMqChannerCascadeList (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/listMqChannerCascades', params, response)
    },
    // 获取mq和通道关联信息列表
    getMqChannerList (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/listMqChanners', params, response)
    },
    // 添加保存mq级联关系
    addMqChannerCascade (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/insertMqChannerCascade', params, response)
    },
    // 修改mq级联关系
    updateMqChannerCascade (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/updateMqChannerCascade', params, response)
    },
    // 删除mq级联关系
    deleteMqChannerCascade (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/deleteMqChannerCascade', params, response)
    },
    // 检查mq级联关系是否存在
    checkMqChannerCascade (params, response) {
        window.vue.$apiAxios.postRequestBody('/databusserver/mqCascadeManager/checkMqChannerCascade', params, response)
    }
}
